import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useMeetingStagesList() {

    //User toast
    const toast = useToast()

    const refMeetingStageListTable = ref(null)

    const tableColumns = [
        {key: 'stage', sortable: true},
        {key: 'description'},
        {key: 'demo', label:'LABEL'},
        {key: 'action'}
    ]

    const perPage = ref(10)
    const totalMeetingStages = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refMeetingStageListTable.value ? refMeetingStageListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalMeetingStages.value,
        }
    })

    const refetchData = () => {
        refMeetingStageListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchMeetingStages = (ctx, callback) => {
        store.dispatch('setting-meetingstage/fetchMeetingStages',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {meetingstages, total} = response.data
            callback(meetingstages)
            totalMeetingStages.value = total
        
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching meeting stages list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchMeetingStages,
        tableColumns,
        perPage,
        currentPage,
        totalMeetingStages,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refMeetingStageListTable,
        ability,
        refetchData
    }

}